import { render, staticRenderFns } from "./DatasetDetails.vue?vue&type=template&id=4dbd82fc&scoped=true&"
import script from "./DatasetDetails.vue?vue&type=script&lang=js&"
export * from "./DatasetDetails.vue?vue&type=script&lang=js&"
import style0 from "./DatasetDetails.vue?vue&type=style&index=0&id=4dbd82fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd82fc",
  null
  
)

export default component.exports